import { generateGUID } from "../utils/generateGUID";

export default function envInnuvaCredentials() {
    const credentials = {
        API_KEY: '5daf0f1057cc4291979bf1227121349b',
        CLIENT_SECRET: 'Vj5X1LMuG687VCvQJ8R19U9Z'
    };
    const authorizationParams = {
        CLIENT_ID: 'WK.ES.A3WebApi.MyReportin',

        /* PRODUCTION */
         REDIRECT_URI: 'https://app.myreportin.com',

        /* DEMO */
         //REDIRECT_URI: 'https://apptest.myreportin.com',

        /* DEV */
        //REDIRECT_URI: 'https://appdev.myreportin.com:4403',

        STATE: generateGUID(),
        NONCE: generateGUID(),
    };


    return { credentials, authorizationParams };
}